export default __webpack_public_path__ + "images/d45e8161c28e452aad17fdb0ebdd9b4a-miami_desktop.webp";